import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the FilterBetsReportView.
 * @extends JetView
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Screen size configuration

        // Left section containing date picker
        const left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Makes the input read-only
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Center left section containing ticket ID input
        const center_left = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for Ticket ID
                    name: 'Id',
                    label: "<span class='icon-ticket'></span>" + _('Ticket Id'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Ticket Id'), // Placeholder text
                },
            ],
        };

        // Center right section containing test selection dropdown
        const center_right = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'richselect', // Dropdown for selecting test status
                    name: 'IsTest',
                    localId: 'isTest:combo', // Local ID for the component
                    label: _('Es Test'), // Label for the dropdown
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                    options: [], // Options for the dropdown
                },
            ],
        };

        // Right section (currently empty)
        const right = {
            margin: 5,
            minWidth: 200,
            rows: [],
        };

        // Upper section containing the main input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive behavior for the section
                    margin: 10,
                    cols: [left, center_left, center_right],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Button to submit the form
                    value: _('Consultar'), // Button label
                    type: 'form', // Indicates this button submits the form
                    autowidth: true,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Retrieves form values
                        this.app.callEvent('betsReport:filter', [filterdata]); // Calls event with filter data
                    },
                },
            ],
        };

        // Returns the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Contains upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form fields
            },
        };
    }
}

// FILE DOCUMENTED
